import axios from 'axios';
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';
const MySwal = withReactContent(Swal);
import { UNAUTHORIZED, INTERNAL_SERVER_ERROR, UNKNOWN_ERROR } from '~/config/constants';
import { alertSwal } from '~/utils/helpers';
import { logout } from '~/stores/redux/common/authSlice';

export const getToken = () => {
    return localStorage.getItem('accessToken')
};

export const storeToken = async (accessToken) => {
    localStorage.setItem('accessToken', accessToken)
};

export const clearToken = () => localStorage.removeItem('accessToken');

export const handleException = (error, path) => {
    if (axios.isCancel(error)) {
        MySwal.fire({
            title: <strong>Oops!</strong>,
            html: (
                <i>
                    Axios request cancelled for resource: {path}. <br></br>Please contact your admin.
                </i>
            ),
            icon: 'error',
            confirmButtonColor: 'rgb(64, 193, 232)',
        });
        throw new Error('axios request cancelled');
    } else {
        if (error.response) {
            const status = error.response?.status;
            const message = error.response?.data?.message ?? INTERNAL_SERVER_ERROR;

            if (status === 400 || status === 404) {
                alertSwal('warning', message);
                throw error.response;
            }

            if (status === 401 || status === 403 || status === 419) {
                if (['/cms-api/login', '/cms-api/logout'].includes(error.config.url)) {
                    throw error.response;
                }
                throw new Error(UNAUTHORIZED);
            }

            //in case where there is POST, PUT, DELATE request so that errors will be displayed on UI.
            if (status === 422) {
                throw error.response;
            }

            alertSwal('error', message);

            throw error.response;
        } else if (error.request) {
            console.log('error.request', error.request); //reduce timeout to 100 to test this error.request
            throw error.message;
            // The request was made but no response was received
            // `error.request` is an instance of     in the browser and an instance of
            // http.ClientRequest in node.js. Ref: https://julietonyekaoha.medium.com/react-cancel-all-axios-request-in-componentwillunmount-e5b2c978c071
        } else {
            // Something happened in setting up the request that triggered an Error
            alertSwal('error', error.message || UNKNOWN_ERROR);
        }
    }
};

export const storeLogInStatus = () => {
    localStorage.setItem('logInStatus', true);
};

export const clearLogInStatus = () => {
    localStorage.removeItem('logInStatus');
};

export const getLogInStatus = () => localStorage.getItem('logInStatus');

export const logoutFE = (dispatch, navigate) => {
    dispatch(logout());

    clearLogInStatus();

    const currentPath = window.location.pathname;
    const redirectTo = '../login' + (currentPath === '/' ? '' : `?redirectTo=${currentPath}`); //https://stackoverflow.com/a/74356083/11297747

    if (!navigate) {
        window.location.href = redirectTo;
        return;
    }
    navigate(redirectTo);
};
